module.exports = __webpack_public_path__ + "media/parallax/separated-leaves-12-9b0e0823.svg";